import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","top":"100px","right":"35px","width":"400px","z-index":"10000"}
}

import notificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  setup(__props) {

const active = computed(() => {
    return notifications.value.length !== 0;
});

const notifications = computed(() => {
    return notificationRepository().notifications;
});

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_unref(active))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                cols: "12",
                key: notification.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_alert, {
                    closable: "",
                    type: notification.type
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(notification.message), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})